import api from "api";

const posEventsApi = {
    list:      (slug, params) => api().get(`/establishments/${slug}/pos-events`, { params }),
    create:    (slug, data)   => api().post(`/establishments/${slug}/pos-events`, data),
    update:    (slug, id, data) => api().put(`/establishments/${slug}/pos-events/${id}`, data),
    remove:    (slug, id)     => api().delete(`/establishments/${slug}/pos-events/${id}`),
    getActive:     (slug)             => api().get(`/establishments/${slug}/pos-events/active`),
    listTickets:   (slug, eventId)       => api().get(`/establishments/${slug}/pos-events/${eventId}/tickets`),
    createTicket:  (slug, eventId, data) => api().post(`/establishments/${slug}/pos-events/${eventId}/tickets`, data),
    listProducts:  (slug, eventId)       => api().get(`/establishments/${slug}/pos-events/${eventId}/products`),
    createProduct: (slug, eventId, data) => api().post(`/establishments/${slug}/pos-events/${eventId}/products`, data),
};

export default posEventsApi;
